module.exports = "https://img.zhijierongxing.com/saas/img/Payment_icon1.bf5e9618.png";